import * as RestApi from 'core/network/RestApi';
import { SubjectLine } from 'models/subject-lines/SubjectLine';

export const getSubjectLines = async ({ siteId }: { siteId: string }): Promise<SubjectLine[]> => {
  const result = await RestApi.get<SubjectLine[]>(`/sites/${siteId}/subject_lines`);
  return result.data;
};
